















	import { Component, Vue, Watch, Provide, Prop } from 'vue-property-decorator';
	import { getRoleOptions } from "@/request/roleList";
	@Component({
		name: 'RoleList'
	})
	export default class RoleList extends Vue {
		// @Provide() private roleValue: string = "";
		@Provide() private roleOptions: any = [];
		@Provide() private token: any = "";
		@Provide() private roleValue: string = "";
		// @Provide() private roleVal: string = "";

		get roleLabel(): string {
			return this.$store.getters.ROLE_INFO.roleLabel;
		}
        // get roleValue(): any {
        //   // this.roleVal = this.$store.getters.ROLE_INFO.name
        //   return this.$store.getters.ROLE_INFO.name;
        // } //  角色
        // set roleValue(val: any) {
        //   this.roleVal = val;
        // } //  角色
		private created() {
			this.token = localStorage.getItem("token");
			this.getRoleListAPI();
			this.resetRole();
		}
		private mounted(): void {
          this.resetRole();
		}
//  lee 获取角色列表
		private getRoleListAPI() {
			getRoleOptions({
				trackId: "",
				clientId: "",
				token: this.token
			}).then((res: any) => {
				switch(res.status){
					case 'success':
						this.roleOptions = res.data;
						break;
					case 'code':
						this.$router.push("./login");
						break;
					case 'error':
						this.$message.error(res.message);
						break;
				}
			}).catch((err: any) => {
				if (err.code == 16) {
					this.$router.push("./login");
				}
			});

		}
// 		private  getRoleListAPI() {
// 			getRoleOptions
// 			let request:any = new CommonReq();
// 			request.setTrackid("");
// 			request.setClientid("");
// 			request.setToken(this.token);
// 			authorClient.listUserGroup(request, {}, (err: any, response:any) => {
// 				if(response) {
// 					let data:any = response.toObject();
// 					if (!data.commonout || (data.commonout.code == 0)) {
// 						if(data.usergroupinfosList) {
// 							this.roleOptions = data.usergroupinfosList;
// 						}
// 					} else if (data.code == 100100 || data.code == 100101) {
// 						this.$router.push("./login");
// 					} else {
// 						this.$message.error(data.commonout.errmsg);
// 					}
// 				}
// 				if (err) {
// 					if (err.code == 16) {
// 						this.$router.push("./login");
// 					}
// 				}
// 			});
// 		}
//  lee 重置角色
		private resetRole() {
			this.$store.commit("SET_ROLE", {
				id: 0,
				name: ''
			});
		}
//  lee 选择角色
		private selectRole(val: any) {
			if(this.roleOptions) {
				let _role: any = this.roleOptions.find( (item: any) => {
					return val == item.name
				});
				this.$store.dispatch('storeRole', _role)	;
			}
		}
	}
